import { Field, FieldProps } from 'formik';
import { FormComponent } from '@synergy/abstract';
import { FormattedMessage } from 'react-intl';
import { PoolTextArea } from '@synergy/components';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

import { Offer } from '../../common/models/offer';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            '&:not(:last-child)': {
                marginBottom: theme.spacing(2),
            },
        },
    });

interface OfferFooterConditionsItemProps extends WithStyles<typeof styles> {
    titleId: string;
    fieldName: string;
    readonly?: boolean;
}

class OfferFooterConditionsItemBase extends FormComponent<Offer, OfferFooterConditionsItemProps> {
    public override render() {
        const { classes, titleId, fieldName, readonly } = this.props;

        return (
            <div className={classes.container}>
                <Field name={fieldName}>
                    {({ field, form }: FieldProps<Offer>) => {
                        return (
                            <PoolTextArea
                                id={fieldName}
                                fullWidth={true}
                                readOnly={readonly}
                                error={this.hasError(form, field.name)}
                                helperText={this.getError(form, field.name)}
                                label={<FormattedMessage id={titleId} />}
                                required={true}
                                {...field}
                            />
                        );
                    }}
                </Field>
            </div>
        );
    }
}

export const OfferFooterConditionsItem = withStyles(styles)(OfferFooterConditionsItemBase);
